'use client';

import type { CategoryModel } from '@coas/db/model';
import { pickLocalized, type Locale } from '@coas/db/utils/i18n';
import { useLocale } from 'next-intl';
import { cn } from '@coas/ui/lib';
import Link from 'next/link';

type CategoryLinkProps = {
    category: CategoryModel;
};

export const CategoryLinkSkeleton = ({ index }: { index: number }) => {
    return (
        <div className={'flex items-center px-[calc(var(--page-gap)/1.5)]'}>
            <span
                className={
                    'animate-pulse select-none rounded-4 bg-neutral-50/50 py-0.5 font-500 text-12 text-transparent leading-none '
                }
            >
                {'_'.repeat(8 + (((index + 1) * 23) % 7))}
            </span>
        </div>
    );
};

export const CategoryLink = ({ category }: CategoryLinkProps) => {
    const locale = useLocale() as Locale;
    const localizedName = pickLocalized(category, 'name', locale);
    return (
        <Link
            href={{ pathname: '/products', query: { category: category.slug } }}
            className={cn(
                'flex items-center px-[calc(var(--page-gap)/1.5)]',
                'text-center text-14 capitalize',
                'text-neutral-50 hover:bg-neutral-200 hover:text-neutral-950',
                'outline-none focus:bg-neutral-200 focus:text-neutral-950',
            )}
        >
            {localizedName.toLocaleLowerCase()}
        </Link>
    );
};
